const sortSelectOptions = [
  {
    label: 'Most completions',
    value: 'mostCompletions',
  },
  {
    label: 'Least completions',
    value: 'leastCompletions',
  },
  {
    label: 'Highest commitment',
    value: 'highestCommitment',
  },
  {
    label: 'Lowest commitment',
    value: 'lowestCommitment',
  },
  {
    label: 'Name (A-Z)',
    value: 'nameAZ',
  },
  {
    label: 'Name (Z-A)',
    value: 'nameZA',
  },
];

const sortByOptionToOrderMap: Record<
  (typeof sortSelectOptions)[number]['value'],
  { orderBy: string; order: 'asc' | 'desc' }
> = {
  nameAZ: {
    orderBy: 'investorName',
    order: 'asc',
  },
  nameZA: {
    orderBy: 'investorName',
    order: 'desc',
  },
  highestCommitment: {
    orderBy: 'resolvedCommitmentAmount',
    order: 'desc',
  },
  lowestCommitment: {
    orderBy: 'resolvedCommitmentAmount',
    order: 'asc',
  },
  mostCompletions: {
    orderBy: 'completedStepsWeight',
    order: 'desc',
  },
  leastCompletions: {
    orderBy: 'completedStepsWeight',
    order: 'asc',
  },
};

export default function useOnboardingInvestorSort<
  T extends string,
>(pagination: {
  orderBy: T;
  order: 'asc' | 'desc';
  handleChangeSort: (orderBy: T, order: 'asc' | 'desc') => void;
}) {
  const sortSelectValue = Object.entries(sortByOptionToOrderMap).find(
    ([_, option]) =>
      option.orderBy === pagination.orderBy &&
      option.order === pagination.order,
  )?.[0];

  const handleChangeSort = (value: string) => {
    const orderBy = sortByOptionToOrderMap[value].orderBy;
    const order = sortByOptionToOrderMap[value].order;
    pagination.handleChangeSort(orderBy as T, order);
  };

  return {
    sortSelectOptions,
    sortSelectValue: sortSelectValue ?? 'nameAZ',
    handleChangeSort,
  };
}
